/** @jsx isolateComponent */

import { ComponentProps } from 'react';

import { AsyncIndicator } from '../../display/AsyncIndicator';
import { Button } from '../../navigation/Button';
import { isolateComponent } from '@zapier/style-encapsulation';

type Props = {
  casing?: ComponentProps<typeof Button>['casing'];
  /**
   * Text that is rendred within the bar. This is intentionally typed as a
   * `string` to discourage injection of arbitrary React elements. This
   * component is for rendering _text_.
   */
  children: string;
  /**
   * Indicates if the content this bar refers to is currently loading.
   * Triggers the rendering of a loading indicator.
   */
  isLoading: boolean;
  /** Callback to be executed when the bar is clicked. */
  onClick?: ComponentProps<typeof Button>['onClick'];
  /** Size of the load more button to render */
  size?: ComponentProps<typeof Button>['size'];
};

const defaultProps = {
  casing: 'uppercase' as 'uppercase',
};

/**
 * A bar that, when clicked, initiates the loading of additional content for
 * the user to view. Usually used to produce an infinite pagination effect.
 */
export const LoadMoreBar = (props: Props) => {
  const { children, isLoading, onClick, size, casing } = {
    ...defaultProps,
    ...props,
  };
  const asyncIndicator = <AsyncIndicator color="grey500" dotSize={6} />;
  return (
    <Button
      casing={casing}
      color="white"
      disabled={isLoading}
      isFullWidth={true}
      onClick={onClick}
      size={size}
    >
      {isLoading ? asyncIndicator : children}
    </Button>
  );
};
